import React from 'react';
import { componentService } from 'js/services/component.service';

export const LoginHistory = React.lazy(() => import(/* webpackChunkName: "login-history" */ './LoginHistory'));

componentService.registerPageComponents({ 'login-history': LoginHistory });
